import React from 'react';
import { Route, Routes } from 'react-router-dom';
import App from '../../App';
import useIsOwnerRouter from './Components/useIsOwnerRouter';
import Loading from '../Loading/Loading';

export interface MainRouterProps {}

const MainRouter: React.FC<MainRouterProps> = (): JSX.Element => {
  const IsOwnerRoute = useIsOwnerRouter();

  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/about" element={<div>About</div>} />
      <Route path="/loading" element={<Loading />} />

      {IsOwnerRoute}

      <Route path="*" element={<div>404 Not Found</div>} />
    </Routes>
  );
};

MainRouter.displayName = 'MainRouter';

export default MainRouter;
